var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmexRecOp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9863 27.9986L41.8567 25.6232L39.645 27.9986H35.3038H25.9659V16.9406H21.6246L27.0307 4.572H32.273L34.157 8.83139V4.572H40.7099L41.8567 7.76654L43.0034 4.572H48V2.68804C48 1.54128 47.099 0.640259 45.9522 0.640259H2.04778C0.901024 0.640259 0 1.54128 0 2.68804V29.3092C0 30.456 0.901024 31.357 2.04778 31.357H45.9522C47.099 31.357 48 30.456 48 29.3092V27.9986H43.9863Z",
    fill: "#0071CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5586 26.6877H47.9989L43.4937 21.855L47.9989 17.1041H44.6405L41.7736 20.2168L38.9886 17.1041H35.5483L40.1354 21.9369L35.5483 26.6877H38.9067L41.7736 23.5751L44.5586 26.6877Z",
    fill: "#0071CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0601 24.4761V23.0017H35.4663V20.7901H30.0601V19.3157H35.5482V17.1041H27.439V26.6877H35.5482V24.4761H30.0601Z",
    fill: "#0071CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4596 15.7119H47.9169V6.04639L43.9852 6.1283L41.8555 12.1078L39.6439 6.1283H35.5483V15.7119H38.1695V8.99519L40.6268 15.7119H42.9204L45.4596 8.99519V15.7119Z",
    fill: "#0071CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3703 6.12817H28.0119L23.7526 15.7118H26.6195L27.4386 13.8278H31.8618L32.6809 15.7118H35.6297L31.3703 6.12817ZM28.3396 11.6162L29.6502 8.5036L30.9608 11.6162H28.3396Z",
    fill: "#0071CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.624 21.6096L47.9995 24.2307V18.9884L45.624 21.6096Z",
    fill: "#0071CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexRecOp);
export default __webpack_public_path__ + "static/media/Amex_rec-op.b484f390f17ce9e84cad6893880a5ffa.svg";
export { ForwardRef as ReactComponent };